import styled from 'styled-components';

import { COLORS } from 'theme';

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 450px;
  display: flex;
`;

export const MapControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s2};
  top: ${({ theme }) => theme.spacing.m2};
  left: ${({ theme }) => theme.spacing.l2};
  transform: scale(0.75);
`;

export const MapControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s2};
  padding: ${({ theme }) => theme.spacing.m2};
`;

export const MapControlButton = styled.button`
  cursor: pointer;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.s2};
  background-color: ${COLORS.white};
  svg path {
    fill: ${COLORS.black40};
  }

  &:hover {
    background-color: ${COLORS.black06};
  }

  &:active {
    background-color: ${COLORS.white};
    svg path {
      fill: ${COLORS.kinetikBlack};
    }
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${COLORS.white};
    svg path {
      fill: ${COLORS.black20};
    }
  }
`;

export const MapControlButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.secondary};
  box-shadow:
    0 16px 64px -12px rgba(0, 0, 0, 0.15),
    0 0 14px -4px rgba(0, 0, 0, 0.05),
    0 16px 48px -8px rgba(0, 0, 0, 0.1);

  ${MapControlButton} {
    /* Round corners for the first button */
    &:first-child {
      border-top-left-radius: ${({ theme }) => theme.borderRadius.secondary};
      border-top-right-radius: ${({ theme }) => theme.borderRadius.secondary};
    }

    /* Delimiter between buttons */
    &:not(:last-child) {
      border-bottom: 1px solid ${COLORS.black06};
    }

    /* Round corners for the last button */
    &:last-child {
      border-bottom-left-radius: ${({ theme }) => theme.borderRadius.secondary};
      border-bottom-right-radius: ${({ theme }) =>
        theme.borderRadius.secondary};
    }
  }
`;

export const InfoWindowContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s1};
`;
